export default __webpack_public_path__ + "assets/13085d0b831690779e2285a1df98b299.jpg";